import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0055FB',
    },
    secondary: {
      main: '#f50057',
    },
  },
  typography: {
    button: {
      textTransform: 'none',
    },
  },
});

export interface AptunoMuiThemeProviderProps {
  children: React.ReactNode;
}

export function AptunoMuiThemeProvider(props: AptunoMuiThemeProviderProps) {
  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
}
